module.exports = __webpack_public_path__ + "img/img-2.3303804d.png";